// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// TODO. Duplicate. Almost the same as LimitOrderEdit.ts.
import { Intervals } from '@shared/utils/Instruments/Intervals';
import { OrderType } from '@shared/utils/Trading/OrderType';
import { DynProperty } from '../../../DynProperty';
import { NumericUtils } from '@shared/utils/NumericUtils';
import { OrderEditUpdateData } from '@shared/utils/Trading/OrderEditUpdateData';
import { SLTPEdit } from '../SLTPEdit';
import { OrderEditBaseUtils } from '@shared/utils/Trading/OrderEditBaseUtils';
import { OrderEditBase } from './OrderEditBase';
export class StopOrderEdit extends OrderEditBase {
    constructor(data) {
        super(data);
        this.stopPrice = null;
        this.sltp = new SLTPEdit(data.dataCache, data.sltpMode);
        this.sltpBasePriceGetter = this.sltpBasePriceGetter.bind(this);
        this.needSetDefaultPrice = false;
    }
    getParameterNameArray() {
        return [
            OrderEditBaseUtils.STOP_PRICE_PARAM,
            OrderEditBaseUtils.POSITION_SIZING_PARAM,
            OrderEditBaseUtils.SLTP_PARAM,
            OrderEditBaseUtils.OFFMARKET_ENABLED,
            OrderEditBaseUtils.EST_AVAILABLE_CASH
        ];
    }
    // TODO. Refactor. Same as OrderTypeBase.Id function.
    getOrderTypeId() {
        return OrderType.Stop;
    }
    // TODO. Refactor. Use error/warning dicts for sltp.
    // public valid ()
    // {
    //     return OrderEditBase.prototype.valid.call(this) &&
    //         this.sltp.valid()
    // }
    // #region Update Parameter Handlers
    update_stopPrice(updateData) {
        let parameterChanged = false;
        const dp = updateData.dp;
        if (dp && this.stopPrice !== dp.value && !(isNaN(this.stopPrice) && isNaN(dp.value))) {
            this.stopPrice = dp.value;
            parameterChanged = true || parameterChanged;
        }
        let newInstrument = null;
        let newQuote = null;
        let sideChanged = false;
        const newTradingDataDict = updateData.newTradingDataDict;
        if (newTradingDataDict) {
            newInstrument = newTradingDataDict.instrument;
            newQuote = newTradingDataDict.quote;
            sideChanged = 'side' in newTradingDataDict;
        }
        if (newInstrument) {
            this.stopPrice = null;
            this.needSetDefaultPrice = true;
            parameterChanged = true || parameterChanged;
        }
        if (this.needSetDefaultPrice && newQuote) {
            this.needSetDefaultPrice = false;
            this.stopPrice = newQuote.BidSpread_SP_Ins(this.instrument.DataCache.GetSpreadPlan(this.account), this.instrument);
            parameterChanged = true || parameterChanged;
        }
        if (newQuote || sideChanged || parameterChanged) {
            parameterChanged = this.tryUpdateWarning_stopPrice(this.stopPrice, this.quote) || parameterChanged;
        }
        return parameterChanged;
    }
    tryUpdateWarning_stopPrice(stopPrice, quote) {
        if (!quote) {
            return false;
        }
        const sp = this.instrument.DataCache.GetSpreadPlan(this.account);
        const ask = quote.AskSpread_SP_Ins(sp, this.instrument);
        const bid = quote.BidSpread_SP_Ins(sp, this.instrument);
        const buy = this.buy();
        const newWarning = buy && stopPrice <= ask
            ? 'general.trading.stopBuyMoreAsk'
            : !buy && stopPrice >= bid
                ? 'general.trading.stopSellLessBid'
                : null;
        return this.warningsManager.setParameterWarning(OrderEditBaseUtils.STOP_PRICE_PARAM, newWarning);
    }
    // #endregion Update Parameter Handlers
    // #region Parameters' DynProperty Generators
    toDynProperty_stopPrice() {
        const dp = new DynProperty(OrderEditBaseUtils.STOP_PRICE_PARAM);
        dp.type = DynProperty.DOUBLE;
        const ins = this.instrument;
        const intrvls = Intervals.GetIntervalsFromInstrument(ins, NumericUtils.MAXVALUE);
        if (ins) {
            dp.minimalValue = intrvls && intrvls.length > 0 ? intrvls[0].LeftValue : ins.PointSize;
            dp.maximalValue = 999999999;
            dp.decimalPlaces = ins.Precision;
            dp.increment = ins.PointSize;
        }
        if (intrvls) {
            dp.Intervals = intrvls;
        }
        dp.value = this.stopPrice;
        if (dp.value === null || isNaN(dp.value)) {
            dp.value = dp.minimalValue;
        }
        dp.localizationKey = 'panel.newOrderEntry.stopPricePanel';
        return dp;
    }
    // #endregion Parameters' DynProperty Generators
    // #region Raw Values
    toRawValue_stopPrice() {
        return this.stopPrice;
    }
    // #endregion Raw Values
    validateParameters() {
        const updatedParamNameDict = {};
        if (this.sltp.validate(this.sltpBasePriceGetter, this.sltpBasePriceGetter, this.getTradingData())) {
            updatedParamNameDict[OrderEditBaseUtils.SLTP_PARAM] = true;
        }
        updatedParamNameDict[OrderEditBaseUtils.POSITION_SIZING_PARAM] = true;
        return updatedParamNameDict;
    }
    // #region SLTP Price Comparer
    sltpBasePriceGetter() {
        return this.stopPrice;
    }
    // #endregion SLTP Price Comparer
    createConfirmationTextParams() {
        const textParams = super.createConfirmationTextParams();
        textParams.OrderTypeKey = 'Stop';
        textParams.PriceArray = [this.stopPrice];
        textParams.OrderType = OrderType.Stop;
        return textParams;
    }
    // Returns SlTpHolder instance.
    // TODO. UGLY. Refactor. details are at the top OrderEditBase.ts
    getRawSLTP() {
        return this.sltp.getRawValue(this.getTradingData());
    }
    // TODO. UGLY. Refactor. details are at the top OrderEditBase.ts
    setStopPrice(price) {
        const dp = this.createDynPropertyFromParameter(OrderEditBaseUtils.STOP_PRICE_PARAM);
        dp.value = price;
        this.updateParameters(new OrderEditUpdateData({ stopPrice: dp }));
    }
    // TODO. Refactor. Details are in OrderEditBase.ts.
    setBasePrice(price) {
        const dp = this.createDynPropertyFromParameter(OrderEditBaseUtils.STOP_PRICE_PARAM);
        dp.value = price;
        this.updateParameters(new OrderEditUpdateData({ stopPrice: dp }));
    }
    // TODO. Refactor. Details are in OrderEditBase.ts.
    getBasePrice() {
        return this.stopPrice;
    }
}
